import { render, staticRenderFns } from "./YellowSection.vue?vue&type=template&id=2866b102&scoped=true"
import script from "./YellowSection.vue?vue&type=script&lang=js"
export * from "./YellowSection.vue?vue&type=script&lang=js"
import style0 from "./YellowSection.vue?vue&type=style&index=0&id=2866b102&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2866b102",
  null
  
)

export default component.exports